// SNAP-2424: decides whether the "Recover account" action is offered. It mirrors
// uni-snaplore-backend-app/src/helpers/accountRecoveryRules.ts. The API enforces the same rules,
// so this only hides an action that would be refused.

export interface AccountRecoveryActor {
  id: string;
  role?: string | null;
  isSuperAdmin: boolean;
}

export interface AccountRecoveryTarget {
  id: string;
  role?: string | null;
  isBot: boolean;
  isSuperAdmin: boolean;
  hasOtherCompanies: boolean;
}

/** True when a member has an active or deactivated membership in any company other than `companyId`. */
export const hasMembershipOutside = (
  member: { companyIds?: string[] | null; inactiveCompanyIds?: string[] | null },
  companyId: string
): boolean =>
  [...(member.companyIds ?? []), ...(member.inactiveCompanyIds ?? [])].some((id) => `${id}` !== `${companyId}`);

export const canStartAccountRecovery = (actor: AccountRecoveryActor, target: AccountRecoveryTarget): boolean => {
  if (actor.id === target.id) return false;
  if (target.isBot || target.role === 'bot') return false;
  if (actor.isSuperAdmin) return true;
  if (target.isSuperAdmin || target.hasOtherCompanies) return false;
  if (!target.role) return false;

  if (actor.role === 'owner') return ['admin', 'moderator', 'user'].includes(target.role);
  if (actor.role === 'admin') return target.role === 'moderator' || target.role === 'user';

  return false;
};
